import { graphene } from 'graphql/tags'

export const passportFavoritesQuery = graphene`#graphql
  query {
    tradeShow {
      edges {
        node {
          slug
          tradeShowBrands {
            edges {
              node {
                brandId
                name
                slug
                mainImage
              }
            }
          }
        }
      }
    }
  }
`
